import { z } from 'zod';

import { HttpsUrl } from './primitives.js';

/**
 * Telemetry event categories. The launcher emits events under one of these
 * categories with category-specific payloads.
 *
 * NOTE: drafted from DESIGN.md / SCHEMA.md hints — concrete event payload
 * shapes will land alongside the engine emitter (Phase 1). OEM modules emit
 * dotted event names (`oem.zebra.dataWedgeApplied`, etc.) under the `oem`
 * category.
 */
export const TelemetryEvent = z.enum([
  'tileLaunch',
  'profileSwitch',
  'configError',
  'licenseError',
  'agentAction',
  'remoteConfigPoll',
  'oem',
  'audit',
]);
export type TelemetryEvent = z.infer<typeof TelemetryEvent>;

/**
 * Enterprise telemetry sink. `authTokenRef` is a reference to a secret
 * (e.g., `secret://acme/telemetry`) resolved by the build pipeline; raw
 * tokens never enter config and never end up in support emails.
 */
export const TelemetryConfig = z.object({
  enabled: z.boolean(),
  // https only — this sink receives device telemetry with an auth token.
  endpoint: HttpsUrl.optional(),
  authTokenRef: z.string().min(1).max(256).optional(),
  events: z.array(TelemetryEvent),
});
export type TelemetryConfig = z.infer<typeof TelemetryConfig>;
